import _typeof from "@babel/runtime/helpers/typeof";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapResponseErrors(errors) {
  return errors.reduce(function (result, error) {
    if (_typeof(error) === 'object' && typeof error.key === 'string') {
      var _ref = error,
        _key = _ref.key,
        message = _ref.message;
      result[_key] = message;
    }
    return result;
  }, {});
}